
















































































































import { Component } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";
import CreateSessionPrintCollectionCode from "./create-sessionPrintCollectionCode.vue";

class PageSessionPrintCollectionCodeRequest extends PageRequest {
  keyword: string;
  type: string;
  fromDate: Date;
  toDate: Date;
}

@Component({
  components: {
    "create-session-print-collection-code": CreateSessionPrintCollectionCode,
  },
})
export default class CollectionCode extends mixins(ListMixin, AbpBase) {
  namespace = "sessionPrintCollectionCode";
  types = [];
  createModalShow: boolean = false;

  pagerequest: PageSessionPrintCollectionCodeRequest = new PageSessionPrintCollectionCodeRequest();
  creationTime: Date[] = [];
  selectedItems = [];
  pageTitlePopup: string = "printer";
  items = [];
  get store() {
    return this.$store.state.collectionCode;
  }
  get list() {
    var re = this.$store.state.sessionPrintCollectionCode.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get totalCount() {
    return this.$store.state.sessionPrintCollectionCode.totalCount;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;

    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async getTypes() {
    await this.$store
      .dispatch({
        type: `collectionCode/getTypesForSelect`,
        data: {
          hasAllItem: true,
        },
      })
      .then(() => {
        var re = this.store.types;
        this.pagerequest.type = re[0].code;
        this.types = re;
      });
  }
  create() {
    this.createModalShow = true;
  }
  columns = [
    {
      title: Util.L("Order"),
      width: 50,
      key: "orderNo",
    },
    {
      title: Util.L("Code"),
      slot: "sessionPrintCode",
    },
    {
      title: Util.L("Qty"),
      width: 100,
      key: "qty",
    },
    {
      title: Util.L("Type"),
      key: "typeName",
    },
    {
      title: Util.L("CreatorUserName"),
      render: (h: any, params: any) => {
        return h(
          "span",
          `${params.row.creatorUser.userName} - ${
            params.row.creatorUser.fullName
          }`
        );
      },
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
  async created() {
    await this.getTypes();
  }
}
